import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, getFormValues } from 'redux-form';
import AsyncSelect from 'react-select/lib/Async';
class WorkLocationForm extends React.Component {
  constructor() {
    super();
    this.state = {
      clientCode: ''
    };
  }

  renderField = ({
    input,
    label,
    type,
    disabled,
    readOnly,
    placeholder,
    maxLength,
    help,
    meta: { touched, error, warning },
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <input
          {...input}
          className="form-control"
          placeholder={placeholder}
          type={type}
          disabled={disabled}
          readOnly={readOnly}
          maxLength={maxLength}
        />
        <small className="help-block">{help}</small>
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  renderSelect = ({
    input,
    readOnly,
    meta: { touched, error, warning },
    label,
    children,
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <select {...input} className="form-control" disabled={readOnly}>
          {children}
        </select>
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  renderTextArea = ({ input, label, meta: { touched, error, warning }, disabled }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <textarea
          {...input}
          className="form-control"
          placeholder={label}
          rows="5"
          cols="30"
          disabled={disabled}
        />
        {touched &&
          ((error && <span>{error}</span>) ||
            (warning && <span>{warning}</span>))}
      </div>
    </div>
  );

  renderClientsSelect = ({
    meta: { touched, error, warning },
    label,
    input,
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <AsyncSelect
          value={input.value}
          cacheOptions
          defaultOptions
          isMulti
          loadOptions={this.searchClients}
          getOptionValue={(option) => option.employerCodeNumber}
          getOptionLabel={(option) => option.employerCodeDescription}
          placeholder="Type Client Name..."
          styles={{
            control: styles => ({
              ...styles,
              borderColor: touched && error ? 'red' : '#cccccc',
            }),
            menu: styles => ({
              ...styles,
              zIndex: 99999,
              color: '#108ee9',
            }),
          }}
          onChange={this.onClientChange}
        />
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  onClientChange = (val) => {
    this.props.change('clients', val);
    this.setState({ clientCode: val.employerCodeNumber });
  }

  searchClients = (search) => {
    return this.props.searchClients(search, 'isActive');
  }

  renderUsersSelect = ({
    meta: { touched, error, warning },
    label,
    input,
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <AsyncSelect
          value={input.value}
          cacheOptions
          defaultOptions
          isMulti
          loadOptions={this.searchUsers}
          getOptionValue={(option) => option.id}
          getOptionLabel={(option) => (option.name === undefined) ? (option.firstName + ' ' + option.lastName) : (option.name)}
          placeholder="Type User Name..."
          styles={{
            control: styles => ({
              ...styles,
              borderColor: touched && error ? 'red' : '#cccccc',
            }),
            menu: styles => ({
              ...styles,
              zIndex: 99999,
              color: '#108ee9',
            }),
          }}
          onChange={this.onUserChange}
        />
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  onUserChange = (val) => {
    this.props.change('users', val);
  }

  searchUsers = (search) => {
    return this.props.searchUsers(search, 'isActive');
  }

  render() {
    const {
      handleSubmit,
      pristine,
      submitting,
      states,
    } = this.props;

    return (
      <form className="form-horizontal" onSubmit={handleSubmit}>
        <fieldset>
          <legend>Work Location</legend>
          <Field
            name="clients"
            component={this.renderClientsSelect}
            label="Client(s)"
          />
          <Field
            className="form-control"
            name="location"
            component={this.renderField}
            type="text"
            placeholder="Work Location"
            label="Work Location"
          />
          <Field
            className="form-control"
            name="address1"
            component={this.renderField}
            type="text"
            placeholder="Address Line 1"
            label="Address Line 1"
          />
          <Field
            className="form-control"
            name="address2"
            component={this.renderField}
            type="text"
            placeholder="Address Line 2"
            label="Address Line 2"
          />
          <Field
            className="form-control"
            name="city"
            component={this.renderField}
            placeholder="City"
            type="text"
            label="City"
          />
          <Field
            className="form-control"
            name="state.id"
            component={this.renderSelect}
            type="text"
            label="State"
          >
            {states &&
              states.map(el => (
                <option key={el.id} value={el.id}>
                  {el.name}
                </option>
              ))}
          </Field>
          <Field
            className="form-control"
            name="zipCode"
            component={this.renderField}
            type="text"
            label="Zip"
            placeholder="Zip"
            maxLength={5}
          />
          <Field
            className="form-control"
            name="phone"
            component={this.renderField}
            type="text"
            placeholder="(XXX) XXX-XXXX"
            label="Phone"
          />
          <Field
            className="form-control"
            name="notes"
            component={this.renderTextArea}
            type="textarea"
            placeholder="Notes"
            label="Notes"
          />
          <Field
            name="users"
            component={this.renderUsersSelect}
            label="Add Users"
          />
        </fieldset>

        <div className="form-actions">
          <div className="row">
            <div className="col-md-12">
              <button
                onClick={this.props.onCancel}
                className="btn btn-default"
                type="button"
              >
                Cancel
              </button>{' '}
              <button
                className="btn btn-primary"
                type="submit"
                disabled={pristine || submitting}
              >
                <i className="fa fa-save" /> Save
              </button>
            </div>
          </div>
        </div>
      </form>
    );
  }
}
const validate = values => {
  const errors = {};
  if (!values.workLocation) {
    errors.workLocation = 'Required';
  }
  if (!values.address1) {
    errors.address1 = 'Required';
  }
  if (!values.city) {
    errors.city = 'Required';
  }
  
  return errors;
};

WorkLocationForm = connect(state => ({
  formValues: getFormValues('workLocation')(state),
  initialValues: state.worklocationmanager.workLocation,
  enableReinitialize: true,
  validate: validate,
}))(reduxForm({ form: 'workLocation' })(WorkLocationForm));
export default WorkLocationForm;



// WEBPACK FOOTER //
// ./src/routes/service-request-manager/components/WorkLocationForm.js